import React from "react";
import "./ClientCards.css";

interface ClientCardsProps {
  clientName: string;
  clientAddress: string;
  logo?: any;
}

const ClientCards: React.FC<ClientCardsProps> = (props) => {
  // Check if logo exists and isn't a placeholder SVG
  const hasValidLogo =
    props.logo &&
    typeof props.logo === "string" &&
    !props.logo.includes("Placeholder");

  // Helper function to extract initials (e.g., "Net Center Logistics" -> "NC")
  const getInitials = (name: string) => {
    return name
      .split(" ")
      .filter(
        (word) =>
          !["Inc.", "Corp.", "Phils.", "Corporation", "Solutions"].includes(
            word
          )
      )
      .slice(0, 2)
      .map((word) => word[0])
      .join("")
      .toUpperCase();
  };

  return (
    <div className="client-cards-container">
      {hasValidLogo ? (
        <img src={props.logo} alt={props.clientName} />
      ) : (
        <div className="client-initials-badge">
          {getInitials(props.clientName)}
        </div>
      )}

      <div className="client-description-container">
        <label>{props.clientName}</label>
        <label className="client-address">{props.clientAddress}</label>
      </div>
    </div>
  );
};

export default ClientCards;